import { render, staticRenderFns } from "./WorkPreference.vue?vue&type=template&id=4596c18f&scoped=true&"
import script from "./WorkPreference.vue?vue&type=script&lang=ts&"
export * from "./WorkPreference.vue?vue&type=script&lang=ts&"
import style0 from "./WorkPreference.vue?vue&type=style&index=0&id=4596c18f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4596c18f",
  null
  
)

export default component.exports